module.exports = __webpack_public_path__ + "img/section1BgM.16b7fdae.webp";